import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { CopyAndEditAttachesExecutorModal } from './CopyAndEditAttachesExecutorModal';
import { ICopyAndEditAttachesExecutorProps } from './ICopyAndEditAttachesExecutorProps';

export const CopyAndEditAttachesExecutor = createDocModalExecutor<ICopyAndEditAttachesExecutorProps>({
    modal: CopyAndEditAttachesExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        actionKey: action.key ?? '',
        displayName: action.displayName ?? '',
        completeHandler,
    }),
});
